module.exports = __webpack_public_path__ + "img/Faulenzen.685c1645.svg";